<template>
  <div class="card collection">
    <div class="header">
      <div style="display: flex;align-items: center;">
        <div class="tag"></div>
        我的收藏
      </div>
<!--      <a-input-search placeholder="请输入商品信息查询" style="max-width: 200px" @search="onSearch"/>-->
    </div>

    <a-tabs default-active-key="tikTok">
      <a-tab-pane key="tikTok" tab="抖音">
        <CollectionView pvd="tikTok"/>
      </a-tab-pane>
      <a-tab-pane key="kuaishou" tab="快手">
        <CollectionView pvd="kuaishou"/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import CollectionView from "@/pages/Setting/mine-collection/collection-view.vue";
export default {
  name: "mine-collection",
  components: {
    CollectionView
  },
  data() {
    return {
    }
  },
  mounted() {
  },

  methods: {
  }
}
</script>

<style scoped lang="scss">
.card {
  background: #FFFFFF;
  box-shadow: 0px 0px 28px 0px rgba(217, 217, 217, 0.19);
  border-radius: 13px;
  padding: 24px;
}

.collection {

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;

    .tag {
      width: 3px;
      height: 15px;
      background: #FA6400;
      margin-right: 4px;
    }

  }

  .goods {
    display: flex;

    .goods-img {
      width: 72px;
      height: 72px;
      border-radius: 8px;
      margin-right: 8px;
    }

    .goods-title {
      font-size: 14px;
      color: #000000;
      line-height: 30px;
    }

    .goods-price {
      font-size: 11px;
      font-weight: 500;
      color: #FF4242;
      line-height: 16px;
    }

    .goods-oprice {
      font-size: 11px;
      font-weight: 500;
      color: #C0C0C0;
      line-height: 16px;
      margin-left: 8px;
      text-decoration: line-through;
    }
  }
}
</style>
